import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PreloaderService {

constructor() { }

show(){
  $( document ).ready(function() {
    var preloader = document.getElementById("preloader");  
    preloader.style.opacity = "1"; 
    preloader.setAttribute("aria-busy", "true");
    document.getElementById("site").style.opacity = "0";
});
  
}


hide()
{
  var preloader = document.getElementById("preloader"); 
  preloader.style.opacity = "0"; 
  preloader.setAttribute("aria-busy", "false");
  document.getElementById("site").style.opacity = "1";
}

}
